/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext } from "react";
import { notification } from "antd";
import authAtom from "../atoms/auth.atom";
import { useMutation } from "react-query";
import { useResetRecoilState } from "recoil";
import { AxiosContext } from "../contexts/AxiosContext";
import { getRequest, handleMessage, postRequest } from "../contexts/AxiosRequests";


export function useAuth(successAction?: any, errorAction?: any) {
  const url = "/fetch_company_details"
  type Payload = { estate_id: string }
  const axios = useContext(AxiosContext)

  return useMutation(
    (payload: Payload) => getRequest(axios as any, url, payload),
    {
      onSuccess: (res: any) => successAction?.(res),
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})}
    }
  )
} 

export function useLogin(successAction?: any, errorAction?: any) {
  const url = "/auth/login"
  const axios = useContext(AxiosContext)
  type Payload = { email: string, password: string, is_security?: boolean, estate_code?: string }

  return useMutation(
    (payload: Payload) => postRequest(axios as any, url, payload),
    {
      onSuccess: (res: any) => {successAction?.(res); notification.success({message: res?.message})},
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})}
    }
  )
} 

export function useForgot(successAction?: any, errorAction?: any) {
  const url = "/auth/password/forgot"
  const axios = useContext(AxiosContext)
  type Payload = { email: string, estate_code?: string }

  return useMutation(
    (payload: Payload) => postRequest(axios as any, url, payload),
    {
      onSuccess: (res: any) => {successAction?.(res); notification.success({message: res?.message})},
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})}
    }
  )
}

export function useReset(successAction?: any, errorAction?: any) {
  const url = "/auth/password/reset"
  const axios = useContext(AxiosContext)
  type Payload = { email: string, password: string, estate_code?: string }

  return useMutation(
    (payload: Payload) => postRequest(axios as any, url, payload),
    {
      onSuccess: (res: any) => {successAction?.(res); notification.success({message: res?.message})},
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})}
    }
  )
}

export function useLogout(successAction?: any, errorAction?: any) {
  const resetAuth = useResetRecoilState(authAtom)

  return useMutation(
    () => resetAuth() as any,
    {
      onSuccess: (res: any) => {successAction?.(res); notification.success({message: "successfully logged out"})},
      onError: (err: any) => {errorAction?.(err); notification.error({message: handleMessage(err)})}
    }
  )
} 